import { DatePipe } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ExtClusterAnalytics } from 'app/models/ext-cluster-analytics.model';
import { MessageService } from 'primeng/api';
import { Observable } from 'rxjs/Observable';
import 'rxjs/Rx';
import { CustomerCard, CustomerCompanyData, CustomerListModel, CustomerRecoveryDto } from '../../models/customer.model';
import { ListMetadata } from '../../models/list-metadata.model';
import { HttpClientService } from '../httpClient/httpclient.service';
import { AuthService } from './../user/auth.service';


@Injectable()
export class CustomersService {

  private isFirstList = false;
  extClusterAnalytics: ExtClusterAnalytics;

  public baseUrl = '/koncentro-customers/v2/customers';
  public baseAPIUrl = '/koncentro-api';
  public customerExtUrl = "/koncentro-customers/customerext";

  constructor (
    private h: HttpClientService,
    private srvNotify: MessageService,
    private datePipe: DatePipe,
    private authService: AuthService,
    private httpClient: HttpClient,
    private translate: TranslateService

    ) { }

  getAll() {
    return this.h.get(this.baseUrl);
  }

  list (
    offset = null,
    limit = null,
    search?: Array<{ key: string, value: string }>,
    globalSearch?: string,
    sort?: string,
    sort_dir?: number
  ): Observable <{data: Array<CustomerListModel>, metadata: ListMetadata}> {

    const indexCd = search.findIndex(f => f.key === "denominazione");
    const indexCn = search.findIndex(f => f.key === "card_no");
    const indexCf = search.findIndex(f => f.key === "vat_fiscal_code");
    //const indexSt = search.findIndex(f => f.key === "store");
    //const indexChD = search.findIndex(f => f.key === "channelDescription");
    const indexBt = search.findIndex(f => f.key === "birth_date");
    const indexCustCode = search.findIndex(f => f.key === "customerCode");
    const indexCity = search.findIndex(f => f.key === "sede");
    //fix KS-6545 per lista carte
    if(indexCd == -1 && indexCn == -1 
      && indexCf == -1
      && indexCustCode == -1
      && indexCity == -1
       //&& indexSt == -1 
       //&& indexChD == -1 
       && indexBt == -1){
      this.srvNotify.add({severity: 'error', summary: this.translate.instant('common.warning'),
        detail: this.translate.instant('card.addFilterTable')});
      return; 
    }
    let params = HttpClientService.buildListParams(offset, limit, search, globalSearch, sort, sort_dir);

    console.log('CUSTOMER LIST FLG_STATE:', params.has('flg_state'), params.get('flg_state'));

    if (this.isFirstList && !params.has('flg_state')) {
      params = params.set('flg_state', '0');
    } else if (this.isFirstList && params.has('flg_state')) {
      this.isFirstList = false;
    }

    if (params.has('flg_state') && params.get('flg_state') === '-1') {
      params = params.delete('flg_state');
    }

    // FIXME: il replace è stato necessario perché un bug di angular non fa l'escape del +
    // FIXME: valutare se gestire la cosa con un interceptor custom come indicato qui https://stackoverflow.com/questions/45428842/angular-url-plus-sign-converting-to-space
    return this.h.postPaged(this.baseUrl + '/getCustomerPagedList' +
      (params.toString() ? '?' + params.toString().replace(/\+/gi, '%2B') : '' ), {});
  }

  deleteCustomer(record) {
    return this.h.delete(this.baseUrl + '/' + record.id)
      .map( () => {
        this.srvNotify.add({severity: 'info', summary: 'Confirmed', detail: 'Customer deleted'});
      });
  }

  recoverCustomer(record) {
    let recordRecovery = new CustomerRecoveryDto();
    recordRecovery.id = record.id;
    recordRecovery.customerCode = record.customerCode;
    return this.h.put(this.baseUrl + '/recover/' + record.id, recordRecovery)
      .map( () => {
        this.srvNotify.add({severity: 'info', summary: 'Recovered', detail: 'Customer Recovered'});
      });
  }

  getCustomerHistoryInfo(hostId) {
    return this.h.get('/koncentro-analytics/history/getCustomerHistoryInfo/' + hostId);
  }

  getCustomerVisitedStoresInfo(hostId, storeId) {
    return this.h.get('/koncentro-analytics/history/getCustomerVisitedStoresInfo/' + hostId + '/' + storeId);
  }

  getCustomerDetails(hostId) {
    return this.h.get(this.baseUrl + '/' + hostId);
  }

  getCustomerDetailsByCardId (cardId): Observable <{data: Array<CustomerCard>, metadata: ListMetadata}> {
    return this.h.get(this.baseUrl + '?card_id=' + cardId);
  }

  getCustomerBaseFilterDefault() {
    return this.h.get('/koncentro-analytics/customerDb/get-base-filter-default');
  }

  getShoppingHabitsCustomerData(searchData) {
    return this.h.post('/koncentro-analytics/shoppingHabits/customer-data', searchData);
  }

  getShoppingHabitsCustomerDetailsData(searchData) {
    return this.h.post('/koncentro-analytics/shoppingHabits/details', searchData);
  }

  getShoppingHabitsMigrationInfo(searchData) {
    return this.h.post('/koncentro-analytics/shoppingHabits/migration-flow-only', searchData);
  }

  getCompanyData(customerId: string) {
    return this.h.get(this.baseUrl + '/' + customerId + '/company').map(res => {
      res.sort((a, b) => {
        const f1 = a.flg_type.toLowerCase();
        const f2 = b.flg_type.toLowerCase();

        if (f1 < f2) {
          return -1;
        }

        if (f1 > f2) {
          return 1;
        }

        return 0;
      });
      return res;
    });
  }

  updateCompanyData(customerId: string, companyData: CustomerCompanyData) {
    return this.h.put(this.baseUrl + '/' + customerId + '/company', companyData);
  }

  addCompanyData(customerId: number, companyData: CustomerCompanyData) {
    return this.h.post(this.baseUrl + '/' + customerId + '/company', companyData);
  }

  deleteCompanyData(customerId: string, companyDataId: string) {
    return this.h.delete(this.baseUrl + '/' + customerId + '/company/' + companyDataId);
  }

  setFirstList() {
    this.isFirstList = true;
  }

  getCustomerAccumulators(customerId) {
    return this.h.get(`${this.baseUrl}/${customerId}/accumulators`);
  }

  getCustomerExtRap(customerId) {
    return this.h.get(`${this.baseUrl}/${customerId}/ext_rap`);
  }

  getCustomerHostById(customerId) {
    return this.h.get(this.baseUrl + '/getCustomerHostById?customerId=' + customerId);
  }

  getInfoCustomers(filters) {

    let params = {};
    if (filters.nation) {
      params['nation'] = filters.nation;
    }
    if (filters.name) {
      params['name'] = filters.name;
    }
    if (filters.surname) {
      params['surname'] = filters.surname;
    }
    if (filters.mobile) {
      params['mobile'] = filters.mobile;
    }
    if (filters.telephone) {
      params['telephone'] = filters.telephone;
    }
    if (filters.email) {
      params['email'] = filters.email;
    }
    if (filters.date_birth != null) {
      params['birthDate'] = this.datePipe.transform(filters.date_birth, 'dd/MM/yyyy');
    }

    return this.h.getPaged(this.baseAPIUrl + '/direct/customer/getInfoCustomers', params);
  }

  getExcelFilename(filters?: any[]) {
    let queryString = '';
    /* Se di tipo Array, filters corrisponde ai filtri della table e vengono inviati in query string,
       altrimenti ai filtri della ExtSearch, quindi vengono inviati come payload
    */
    let data = Array.isArray(filters) ? {} : filters;
    if (Array.isArray(filters) && filters.length > 0) {
      filters.forEach(filter => queryString += `${filter.key}=${filter.value}&`);
    }
    return this.h.post(queryString.length > 0 ? `${this.baseUrl}/exportCustomers?${queryString}` : `${this.baseUrl}/exportCustomers`, data);
  }

  downloadExcel(filename: string): Observable<Blob> {
    const requestBody = {'filename': filename};
    const userCompany = this.authService.user.selectedCompany.toString();
    const token =  `Bearer ${this.authService.user.token}`;
    const language = this.authService.sessionHelper.selectedLanguage;
    const requestHeaders = {
      'Accept-Company': userCompany,
      'Content-Type': 'application/json',
      'Authorization': token,
      'Accept-Language': language
    };
    return this.httpClient.post(
      '/koncentro-customers/download',
      requestBody,
      {
        headers: requestHeaders,
        responseType: 'blob'
      }
    );
  }

  sendExtSearchQuery(data): Observable<{ data: any, metadata: ListMetadata }> {
    if (data.sortField && data.sortDir) {
      return this.h.postPaged(`${this.baseUrl}/getCustomerPagedList?offset=${data.offset}&limit=${data.limit}&sort=${data.sortField}&sort_dir=${data.sortDir}`, data.query);
    } else {
      return this.h.postPaged(`${this.baseUrl}/getCustomerPagedList?offset=${data.offset}&limit=${data.limit}`, data.query);
    }
  }

  /**
   * Chiamata per ottenere i cluster di un cliente, nell'apposito Tab 
   * @param customerHostId customer_host.id di un cliente
   * @returns 
   */
  getExtClusterAnalytics(customerHostId: number) {
    return this.h.get(`${this.customerExtUrl}/${customerHostId}/extClusterAnalytics`);
  }

}



// WEBPACK FOOTER //
// ./src/app/services/customer/customers.service.ts